import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { check } from '../../../Utils/FormCalls';
import { decode as base64_decode } from 'base-64';
import TableView from '../../../Widgets/TableView';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import { Form, message, Select, Input, Modal,Button } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { PaperClipOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';
import {
  StyledSubHeading,
  StyledBox
} from '../../../CSS/style';
import {
  getDeviceList,
  getSitesList,
  // getHierarchyList,
  submitMaster,
  // getJobPlansList,
  getLocationByAsset,
  // getWorkTypes,
  getMasterById,
  getStatus
} from '../../../Utils/FormCalls';
import {
  API_DEVICE,
  // API_HIERARCHYMODULE,
  API_MASTERMATERIALS,
  API_PARAMETER
} from '../../../../../commons/api';

const { Option } = Select;
const type = 'Material';
const urlList = {
  insert: API_MASTERMATERIALS.INSERT,
  getbyId: API_MASTERMATERIALS.GetById
};

const MaterialDetails = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  // const [selectedJobPlan, setSelectedJobPlan] = useState(props.formObject && props.formObject.JobPlanName ? props.formObject.JobPlanName : '');
  const [datasource, setDatasource] = useState(props.formObject && props.formObject.Specifications ? props.formObject.Specifications : [{}]);
  const [, setStatus] = useState('false');
  const [tableData, setTableData] = useState([]);
  const [DeviceAlias, setDeviceAlias] = useState('');
  const [translationCache, setTranslationCache] = useState([]);
  const [columns] = useState([
    {
      title: translation(props.translationCache, constant.name),
      key: 'Name',
      dataIndex: 'Name',
      widget: 'input',
      required: true
    },
    {
      title: translation(props.translationCache, constant.value),
      key: 'Value',
      dataIndex: 'Value',
      widget: 'inputNumber',
      required: true
    },
    {
      title: translation(props.translationCache, constant.unitOfMeasure),
      key: 'UOM',
      dataIndex: 'UOM',
      widget: 'select',
      required: true,
      table: {
        url: `${API_PARAMETER.GetUOM}`,
        method: 'GET'
      }
    }
  ]);
  const [fileData, setFileData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const prevProps = useRef(props);
  const materialRef = useRef();
  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        const response = await axios.get(`${API_DEVICE.LIST}?SiteId=${localStorage.get('currentSite')}`, {
          headers: {
            Authorization: `Bearer ${localStorage.get('accessToken')}`
          }
        });
        setTableData(response.data);
      } catch (error) {
        message.error('Error fetching data');

      }
      // try {
      //   const hierarchyList = await getHierarchyList();
      //   setHierarchyList(hierarchyList);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
      try {
        const deviceList = await getDeviceList();
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        const sitesList = await getSitesList();
        let formObject = materialRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        materialRef.current.setFieldsValue(formObject);
        setSitesList(sitesList);
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      // try {
      //   const JobPlansList = await getJobPlansList('Active');
      //   setJobPlansList(JobPlansList);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
      // try {
      //   const workTypes = await getWorkTypes();
      //   setWorkTypesList(workTypes);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
      try {
        const Status = await getStatus();
        setStatus(Status);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (materialRef.current) materialRef.current.setFieldsValue(props.formObject);
    }

    if (prevProps.formObject !== props.formObject) {
      setFormObject(props.formObject);
      setDatasource(props.formObject && props.formObject.Specifications ? props.formObject.Specifications : [{}]);
    }
  }, [props]);

  const _getDataById = async (MaterialId) => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/MaterialDetails/');
    let formId = MaterialId ? MaterialId : base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getMasterById(urlList.getbyId, formId, 'GET');
      formObject = data && data !== undefined ? data : {};
    }
    setFormObject(formObject);
    setDatasource(formObject.Specifications);
    setDeviceAlias(formObject.DeviceAlias);
    if (formObject) {
      materialRef.current && materialRef.current.setFieldsValue(formObject);
    }
  };

  // const handleSelect = (value, mainIndex, subindex, keyName) => {
  //   let list = {};
  //   let TaskData = list;
  //   TaskData.map((item, index) => {
  //     if (index === mainIndex) {
  //       item[keyName][subindex]['TotalQuantity'] = value;
  //     }
  //     return {};
  //   });
  // };

  const handleChange = async (value, key) => {
    let currentFormObject = materialRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      [key]: value
    };

    if (key === 'DeviceId') {
      let selectedDevice = deviceList.filter((item) => item.Id === value);
      if (selectedDevice.length > 0) {
        let location = await getLocationByAsset(selectedDevice[0]);
        currentFormObject = {
          ...currentFormObject,
          [key]: value,
          LocationId: location.data.Name
        };
      }
    }

    if (materialRef.current) {
      materialRef.current.setFieldsValue(currentFormObject);
    }

    setFormObject(currentFormObject);
  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObject = materialRef.current.getFieldsValue();
    if (formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    formObject[key] = formObject[key] && formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    formObject = {
      ...formObject,
      Specifications: datasource,
      [key]: formObject[key]
    };
    setFileData(prev => [...prev, fileDataObject]); // Update fileData state
    if (materialRef.current) materialRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFormsubmit = async (values) => {
    let userId = props.userProfile && props.userProfile.user && props.userProfile.user.Id ? props.userProfile.user.Id : '';
    let Specifications = [];
    let SpecificationsForm = formObject && formObject.Specifications ? formObject.Specifications : [];
    if (SpecificationsForm && Array.isArray(SpecificationsForm)) {
      let editableList = SpecificationsForm.filter((specifi) => specifi.editable === true);
      if (editableList && Array.isArray(editableList) && editableList.length === 0) {
        Specifications = SpecificationsForm.map((spec) => {
          delete spec.editable;
          delete spec.key;
          return spec;
        });
        let payload = {
          ...formObject,
          ...values,
          ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
          ...(formObject && formObject.Id ? { UpdatedBy: userId } : {}),
          Specifications,
          Equipment: DeviceAlias
        };
        let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
        if (statusResponse && statusResponse.message) {
          _getDataById(statusResponse.Id);
          message.success(statusResponse.message);
          props.navigate('/rubus/AMM/MaterialList');
        } else if (statusResponse && statusResponse.Error) {
          message.error(statusResponse.Error);
        }
      } else {
        message.warning('Please save specifications before submitting');
      }
    }
  };

  const onReset = () => {
    if (materialRef.current) materialRef.current.resetFields();
  };

  const saveTableViewData = (datasource) => {
    let formObject = materialRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      Specifications: datasource
    };
    setFormObject(formObject);
    setDatasource(datasource);
  };

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setFormObject(materialRef.current.getFieldsValue());
        setVisible(true);
      })
      .catch((error) => {
        console.error("Error fetching device data:", error);
      });
  };
  const TableDropdownChange = (value) => {
    let formObject = materialRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      Equipment: value.AliasCode,
      DeviceCode: value.DeviceCode,
      EquipmentDescription: value.Name,
      DisplayCode: value.DisplayCode
    };

    materialRef.current.setFieldsValue(formObject);

    setFormObject(formObject);
    setDeviceAlias(value && value.AliasCode);
    setVisible(false);
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
 const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 
  return (
    <>
      <Form
        name="Item"
        ref={materialRef}
        initialValues={formObject}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          }
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type='primary' htmlType="submit">
              {translation(props.translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.material)}
              name="Material"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Material')}
                disabled={formObject && formObject.Id ? true : false}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.materialDescription)}
              name="Description"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Material Description')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <Input
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Select Equipment')}
                disabled={true}
                suffix={
                  <DownOutlined
                    style={{
                      color: formObject && formObject.Id ? null : '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  />
                }
              />
            </Form.Item>

            <Modal
              open={visible}
              width={800}
              closable
              title={translation(props.translationCache, constant.selectEquipment)}
              onOk={() => setVisible(false)}
              onCancel={() => setVisible(false)}
            >
              <TableSelect
                data={tableData}
                translationCache={props.translationCache}
                key={translation(props.translationCache, 'Location')}
                columns={[
                  {
                    title: translation(props.translationCache, 'Equipment'),
                    dataIndex: 'DisplayCode',
                    key: 'DisplayCode',
                    ...getColumnSearchProps('DisplayCode')
                  },
                  {
                    title: translation(props.translationCache, `Equipment Description`),
                    dataIndex: 'Name',
                    key: 'Name',
                    ...getColumnSearchProps('Name')
                  }
                ]}
                handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
              />
            </Modal>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Autopopulate based on Equipment')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                disabled={formObject && formObject.Id ? true : false}
                placeholder={translation(props.translationCache, 'Select Site')}
                onChange={(e) => handleChange(e, 'SiteId')}
              >
                {sitesList && Array.isArray(sitesList) && sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              name="Attachments"
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {translation(props.translationCache, constant.attachments)}
                    <PaperClipOutlined className="plusCircleOutlined" />
                  </span>
                </div>
              }
            >
              <FileBase64
                style={{ width: '70%' }}
                downloadClassName={'formdownloadInput'}
                Attachments={formObject.Attachments}
                fileUpload={fileupload}
              />
            </Form.Item>
          </StyledBox>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.issueUnit)}
              name="IssueUnit"
              rules={[{ message: 'field does not accept special characters' }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Issue Unit')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.relatedEquipment)}
              name="RelatedEquipment"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Related Equipment')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.toolName)}
              name="ToolName"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input ToolName')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.drawings)}
              name="Drawings"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Drawings')}
              />
            </Form.Item>
          </StyledBox>
          <StyledBox  themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.storeLocation)}
              name="StoreLocation"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Store Location')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%', marginTop: '30px' }}
              label={translation(props.translationCache, constant.Remarks)}
              name="Remarks"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Remarks')}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(props.translationCache, constant.Quantity)}
              name="AvailableQuantity"
              rules={[
                { required: true },
                {
                  validator: (_, value) => check(value, 'Item', { validateDecimal: true })
                }
              ]}
            >
              <InputNumberComponent
                style={{ width: '70%' }}
                placeholder={translation(props.translationCache, 'Input Quantity')}
                onChange={(e) => handleChange(e, 'Quantity')}
              />
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }}>
              <InputComponent style={{ display: 'none' }} />
            </Form.Item>

            <Form.Item name="Equipment"></Form.Item>
          </StyledBox>
        </div>
        <StyledSubHeading>
          {translation(props.translationCache, constant.specifications)}
        </StyledSubHeading>
        <Form.Item>
          <TableView
            form={{ columns: columns, datasource: datasource }}
            recordType={'FormSubSectionTable'}
            saveTableViewData={saveTableViewData}
            showAddButton={true}
          />
        </Form.Item>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile,
  };
};

export default connect(mapStateToProps)(MaterialDetails);